import React from 'react'
import Map from './components/Map'

export default () => {
    return (
        <>
            <Map />
        </>
    )
}